import React from 'react'

import { useLocation } from 'react-router'

type Props = {
  children: React.ReactNode
  open?: boolean
  summary: string
}

type ElementProps = {
  children?: React.ReactNode
  href?: string
}

const findMatchingHref = (node: React.ReactNode, currentPath: string): boolean => {
  if (!React.isValidElement<ElementProps>(node)) {
    if (Array.isArray(node)) {
      return node.some((child) => findMatchingHref(child, currentPath))
    }

    return false
  }

  if (node.props.href === currentPath) {
    return true
  }

  return React.Children.toArray(node.props.children).some((child) => findMatchingHref(child, currentPath))
}

export default function Details({ children, summary, open = false }: Props) {
  const location = useLocation()
  const currentPath = location.pathname

  const shouldBeOpen = React.useMemo(() => {
    return findMatchingHref(children, currentPath) || Boolean(open)
  }, [children, currentPath, open])

  return (
    <details open={shouldBeOpen ? true : undefined}>
      <summary className='details-summary'>{summary}</summary>
      <div className='details-content'>{children}</div>
    </details>
  )
}

Details.scheme = {
  render: 'Details',
  attributes: {
    open: {
      type: Boolean
    },
    summary: {
      type: String
    }
  }
}
